export const pillars = ['Hangul', 'Pronunciation', 'Vocabulary', 'K-Drama', 'Routine', 'Community'];

export const volumes = [
  {
    n: 1,
    emoji: '🧩',
    title: 'Hangul Explained Without Complications',
    desc: 'Understand how the Korean alphabet works clearly and step by step, so you can read and write with confidence — even if you have never studied Korean before.',
  },
  {
    n: 2,
    emoji: '🎤',
    title: 'Basic Pronunciation That Actually Sounds Right',
    desc: 'Learn to produce the essential sounds and avoid the most common mistakes English speakers make when speaking, even if you have never studied any language.',
  },
  {
    n: 3,
    emoji: '🗣️',
    title: 'Real Everyday Phrases & Expressions',
    desc: 'Incorporate the essential vocabulary and expressions that actually appear in K-Dramas, so you can use the language in real situations from the first week.',
  },
  {
    n: 4,
    emoji: '📅',
    title: '30-Day Routine With Visible Progress',
    desc: 'Follow an easy daily plan to advance without getting lost, measure your progress with clear milestones and keep your motivation high until day 30.',
  },
  {
    n: 5,
    emoji: '🎬',
    title: 'Understand K-Dramas & K-Pop (Finally)',
    desc: 'By the end of 30 days you will catch 30-40% of the dialogue without subtitles and understand song lyrics like never before.',
  },
  {
    n: 6,
    emoji: '💬',
    title: 'Join The K-Community Confidently',
    desc: 'Make real Korean friends, take part in fandom communities and have your first real conversation in Korean without freezing.',
  },
];

export const volumeIncludes = [
  'Visual step-by-step lessons',
  'Romanization + translation',
  'Pronunciation drills',
  'Real K-Drama examples',
  'Daily practice checklists',
  'Printable review sheets',
  'Designed for absolute beginners',
  'Ready to apply from today',
];

export const bonuses = [
  {
    n: '01',
    title: '+100 VISUAL KOREAN FLASHCARDS™',
    desc: 'A pack of visual flashcards ready to use for reviewing Hangul, basic phrases, everyday vocabulary, K-Drama expressions and travel Korean. Perfect for studying on your phone, printing and practicing step by step.',
    price: '$37',
  },
  {
    n: '02',
    title: 'HANGUL EXPRESS™ — READ KOREAN FROM ZERO',
    desc: 'A quick and simple guide to understanding the Korean alphabet from scratch, recognizing its letters, understanding how syllables are formed and reading your first words without feeling overwhelmed.',
    price: '$25',
  },
  {
    n: '03',
    title: 'K-DRAMA & K-POP PHRASES™ (50 MUST-KNOW EXPRESSIONS)',
    desc: 'A selection of frequent phrases and expressions to start recognizing words in K-Dramas, songs, interviews and Korean content. Includes translation, romanization and practical usage.',
    price: '$20',
  },
  {
    n: '04',
    title: '30-DAY KOREAN CHALLENGE CALENDAR™',
    desc: 'A simple and organized calendar so you know exactly what to practice each day, build your study habit and advance from zero without getting lost or quitting halfway through.',
    price: '$19',
  },
  {
    n: '05',
    title: 'THE K-SMART INNER CIRCLE (PRIVATE DISCORD)',
    desc: 'Exclusive access to our private Discord community of Korean learners. Share progress, ask questions, join weekly challenges and find study buddies from all over the world.',
    price: '$47',
  },
];
